import { render } from "./SmartControl.vue?vue&type=template&id=5f4c42aa&scoped=true&lang=pug"
import script from "./SmartControl.vue?vue&type=script&lang=js"
export * from "./SmartControl.vue?vue&type=script&lang=js"

import "./SmartControl.vue?vue&type=style&index=0&id=5f4c42aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4c42aa"]])

export default __exports__